import { arrayPush } from "redux-form";

import { PERMITTED_IP_FIELD } from "./ipRestrictions.constants";
import { USER_FORMS } from "../../../constants/forms";

export const addIpRestrictions = (item) =>
  arrayPush(USER_FORMS.IP_RESTRICTIONS, PERMITTED_IP_FIELD, item);
